import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Subcategories per main category
export const SUBCATEGORIES = {
  food: [
    { id: "snacks_creoles", label: "Snacks créoles" },
    { id: "food_trucks", label: "Food trucks" },
    { id: "brunch", label: "Brunch" },
    { id: "bars", label: "Bars" },
    { id: "restaurants", label: "Restaurants" },
  ],
  activities: [
    { id: "plages", label: "Plages" },
    { id: "randonnées", label: "Randonnées" },
    { id: "cascades", label: "Cascades" },
    { id: "surf", label: "Surf" },
    { id: "famille", label: "Famille" },
  ],
  events: [
    { id: "concerts", label: "Concerts" },
    { id: "festivals", label: "Festivals" },
    { id: "marchés", label: "Marchés" },
    { id: "culturels", label: "Événements culturels" },
  ],
  beauty: [
    { id: "instituts", label: "Instituts" },
    { id: "spa", label: "Spa" },
    { id: "coiffure", label: "Coiffure" },
    { id: "ongles", label: "Ongles" },
  ],
  shop: [
    { id: "souvenirs", label: "Souvenirs" },
    { id: "marchés", label: "Marchés" },
    { id: "épicerie", label: "Épicerie" },
    { id: "mode", label: "Mode" },
  ],
  nightlife: [
    { id: "clubs", label: "Clubs" },
    { id: "bars_ambiance", label: "Bars ambiance" },
    { id: "rooftops", label: "Rooftops" },
    { id: "beach_parties", label: "Beach parties" },
    { id: "dj_sets", label: "DJ sets" },
  ],
};

export const CATEGORIES = [
  {
    id: "food",
    label: "Food",
    icon: "UtensilsCrossed",
    color: "#FF6B35",
    image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=600",
    tagline: "Saveurs péi",
  },
  {
    id: "activities",
    label: "Activités",
    icon: "Mountain",
    color: "#2A9D8F",
    image: "https://images.unsplash.com/photo-1502680390469-be75c86b636f?w=600",
    tagline: "Plages, randos, surf",
  },
  {
    id: "events",
    label: "Événements",
    icon: "PartyPopper",
    color: "#00A6B3",
    image: "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=600",
    tagline: "Concerts & festivals",
  },
  {
    id: "nightlife",
    label: "Night Life",
    icon: "Moon",
    color: "#6C2BD9",
    image: "https://images.unsplash.com/photo-1572116469696-31de0f17cc34?w=600",
    tagline: "Clubs, rooftops, DJ",
  },
  {
    id: "beauty",
    label: "Beauté",
    icon: "Flower2",
    color: "#E91E63",
    image: "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=600",
    tagline: "Spa & instituts",
  },
  {
    id: "shop",
    label: "Shopping",
    icon: "ShoppingBag",
    color: "#F4A261",
    image: "https://images.unsplash.com/photo-1488459716781-31db52582fe9?w=600",
    tagline: "Marchés & boutiques",
  },
];

export const CATEGORY_LABELS = CATEGORIES.reduce((acc, c) => {
  acc[c.id] = c.label;
  return acc;
}, {});

export const CATEGORY_COLORS = CATEGORIES.reduce((acc, c) => {
  acc[c.id] = c.color;
  return acc;
}, {});

export const SUBCATEGORY_LABELS = Object.entries(SUBCATEGORIES).reduce((acc, [_, subs]) => {
  subs.forEach(s => { acc[s.id] = s.label; });
  return acc;
}, {});
